import { detectDeviceType } from '../helpers';

export const MY_CARDS_EVENT = {
  PageName: 'myCards',
  Device: detectDeviceType,
};

export const THANK_YOU_EVENT = {
  PageName: 'thankYouPage',
  Device: detectDeviceType,
};

export const PROBLEM_WITH_ACCOUNT_EVENT = {
  PageName: 'problemWithAccount',
  Device: detectDeviceType,
  MessageType: '',
};

export const API_SYSTEM_ERROR_EVENT = {
  PageName: 'APISystemError',
  Device: detectDeviceType,
  MessageType: '',
};

export const LINK_NOT_VALID_EVENT = {
  PageName: 'linkNotValid',
  Device: detectDeviceType,
  MessageType: '',
};

export const ACCOUNT_NOT_FOUND_EVENT = {
  PageName: 'accountNotFound',
  Device: detectDeviceType,
  MessageType: '',
};

export const NOT_AUTHENTICATED_ERROR_EVENT = {
  PageName: 'notVerifiedError',
  Device: detectDeviceType,
  MessageType: '',
};

export const CAPTURE_CLICK_EVENT = {
  Device: detectDeviceType,
};

export const PII_PAGE_LOAD_EVENT = {
  Device: detectDeviceType,
  PageFunction: 'scaLookup',
  PageKind: 'scaLookup',
  PageName: 'piPage',
};

export const SESSION_EXPIRY_POPUP_EVENT = {
  Device: detectDeviceType,
  PageFunction: 'scaLookup',
  PageKind: 'scaLookup',
  PageName: 'logoutPopUpModule',
};

export const SESSION_TIMED_OUT_ERROR_EVENT = {
  PageName: 'sessionTimeoutError',
  Device: detectDeviceType,
  MessageType: '',
};

export const CANCEL_POPUP_EVENT = {
  Device: detectDeviceType,
  PageFunction: 'scaLookup',
  PageKind: 'scaLookup',
  PageName: 'piPageCancelPopUp',
};

export const NEW_ACCOUNT_ERROR_EVENT = {
  Device: detectDeviceType,
  PageFunction: 'scaLookup',
  PageKind: 'scaLookup',
  PageName: 'NewAccountError',
  MessageType: '',
  PageSubFunction: '',
};

export const CREDIT_INCREASE_REQUEST = {
  Device: detectDeviceType,
  PageFunction: 'creditLimitIncrease',
  PageName: 'start',
  PageKind: 'scaLookup',
};

export const CREDIT_INCREASE_SUCCESS = {
  Device: detectDeviceType,
  PageFunction: 'creditLimitIncrease',
  PageName: 'approved',
  PageKind: 'scaLookup',
};

export const CREDIT_INCREASE_PARTIAL_SUCCESS = {
  Device: detectDeviceType,
  PageFunction: 'creditLimitIncrease',
  PageName: 'partiallyApproved',
  PageKind: 'scaLookup',
};

export const CREDIT_INCREASE_UNDER_REVIEW = {
  Device: detectDeviceType,
  PageFunction: 'creditLimitIncrease',
  PageName: 'underReview',
  PageKind: 'scaLookup',
};

export const CREDIT_INCREASE_DENIED = {
  Device: detectDeviceType,
  PageFunction: 'creditLimitIncrease',
  PageName: 'creditIncreaseDeclined',
  PageKind: 'scaLookup',
};

export const CREDIT_INCREASE_ERROR = {
  Device: detectDeviceType,
  PageFunction: 'creditLimitIncrease',
  PageName: 'error-1',
  PageKind: 'scaLookup',
};
